import styled from "styled-components"

import { minWidth, when } from "utils"

export const Container = styled.div`
  width: calc(100% - 5.4rem);
  margin: 0 2.7rem 2rem;
  clear: both;

  ${minWidth.tablet`
    max-width: 58rem;
    margin: 0 auto 4rem;
  `}

  ${minWidth.desktop`
    max-width: 72.5rem;
  `}

  ${when("showBorder")`
    border: 0.1rem solid #d3d3d3;
  `}
`
